import { Dialog } from "@mui/material";
import { usePlaySound } from "common/utils";
import { CloseBtn, FadeTransition } from "common/elements";

export const ChatImageViewer = ({
  visible,
  url,
  close,
}: {
  visible: boolean;
  url?: string;
  close: () => void;
}) => {
  const play = usePlaySound();

  const handleClose = () => {
    play();
    close();
  };

  return (
    <Dialog
      fullScreen
      open={visible}
      maxWidth={false}
      sx={{ zIndex: 2147483646 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div className="flex-col-el flex-center relative">
          <img src={url} className="max-w-[80vw] max-h-[80vh] object-contain" />
          <CloseBtn close={handleClose} />
        </div>
      </div>
    </Dialog>
  );
};
